<script setup lang="ts">
  import { computed, useSlots, type VNode } from 'vue'

  defineProps<{
    label: string,
  }>()

  const slots = useSlots()
  const slotHasItem = computed(() => {
    // Check if the 'default' slot has any rendered content
    const defaultSlotContent = slots.default?.({}) as VNode[] | undefined
    return defaultSlotContent?.some((v) => typeof v.children !== 'string')
  })
</script>

<template>
  <div>
    <div
      v-if="slotHasItem"
      class="sidebar-group-label">
      {{ label }}
    </div>
    <slot></slot>
  </div>
</template>
